import React from 'react';
import clsx from 'clsx';

import styles from '../styles.module.scss';
import modStyles from './Mod.module.scss';
import CircleRangeSliderPage from '../../dashboard/bodyDashboard/overview/CircleRangeSliderPage';

export const ModerationCard = () => {
  return (
    <div className={modStyles.mod}>
      <div className={modStyles.modInner}>
        <div className={clsx(styles.label, styles.ai)}>
          <div className={clsx(styles.labelInner, styles.ai)}>AI</div>
        </div>
        <h4 className={styles.title}>ML-Driven Moderation</h4>
        <p className={styles.subTitle}>
          Themis utilizes machine learning to swiftly detect and eliminate spam, fake accounts, and
          more, ensuring your community is safe and spam-free.
        </p>
      </div>
      <div className={modStyles.infoWrapper}>
        <CircleRangeSliderPage min={0} max={100} colorBg={'#EF9D00'} valueSecurity={62} />
        <CircleRangeSliderPage min={0} max={100} colorBg={'#D8B98D'} valueSecurity={100} />
        <CircleRangeSliderPage min={0} max={100} colorBg={'#58B90A'} valueSecurity={76} />
      </div>
    </div>
  );
};
